import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { FormGroup, FormControlLabel } from 'material-ui/Form';
import TextField from 'material-ui/TextField';
import Switch from 'material-ui/Switch';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';
import Snackbar from 'material-ui/Snackbar';
import CopyToClipboard from 'react-copy-to-clipboard';
import PWGenerator from 'generate-password';

class PasswordGenerator extends Component {
	state = {
		showCopyMessage: false,
		password: '',
		length: 20,
		numbers: true,
		uppercase: true,
		excludeSimilarCharacters: true,
		symbols: false,
		strict: false
	}

	componentWillMount() {
		this.generatePassword();
	}

	generatePassword = () => {
		const { length, numbers, uppercase, excludeSimilarCharacters, symbols, strict } = this.state;
		let password = PWGenerator.generate({
			length,
			numbers,
			uppercase,
			excludeSimilarCharacters,
			symbols,
			strict
		});

		this.setState({ password });
	}

	handleChange = (event, checked) => {
		this.setState({
			[event.target.name]: typeof checked !== 'undefined' ? checked : event.target.value
		}, this.generatePassword);
	}

	toggleCopiedMessage = () => {
		this.setState({
			showCopyMessage: !this.state.showCopyMessage
		});
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
				<div className={classes.container}>
					<TextField name="length" label="Length" type="number" value={this.state.length} fullWidth={true} onChange={this.handleChange} />
				</div>
				<FormGroup row>
					<FormControlLabel control={<Switch name="numbers" checked={this.state.numbers} onChange={this.handleChange} />} label="Numbers" />
					<FormControlLabel control={<Switch name="uppercase" checked={this.state.uppercase} onChange={this.handleChange} />} label="Uppercase" />
					<FormControlLabel control={<Switch name="excludeSimilarCharacters" checked={this.state.excludeSimilarCharacters} onChange={this.handleChange} />} label="Exclude similar characters" />
					<FormControlLabel control={<Switch name="symbols" checked={this.state.symbols} onChange={this.handleChange} />} label="Symbols" />
					<FormControlLabel control={<Switch name="strict" checked={this.state.strict} onChange={this.handleChange} />} label="Strict" />
				</FormGroup>
				<div className={classes.container}>
					<CopyToClipboard text={this.state.password} onCopy={this.toggleCopiedMessage}>
						<Button color="primary">Copy password</Button>
					</CopyToClipboard>
					<Button onClick={this.generatePassword}>Generate password</Button>
				</div>
				<Paper className={classes.paper}><Typography>{this.state.password}</Typography></Paper>
				<Snackbar message="Password has been copied to the clipboard" open={this.state.showCopyMessage} autoHideDuration={5000} onClose={this.toggleCopiedMessage} />
			</div>
		);
	}
};

PasswordGenerator.propTypes = {
	classes: PropTypes.object.isRequired
};

const styles = theme => ({
	container: {
		marginTop: theme.spacing.unit * 3
	},
	paper: {
		padding: theme.spacing.unit * 3,
		marginTop: theme.spacing.unit * 3,
		overflow: 'hidden'
	}
});

export default withStyles(styles)(PasswordGenerator);



// WEBPACK FOOTER //
// ./src/components/PasswordGenerator/index.js